import React, { useContext, useState } from 'react';
import About from '../components/About/About';
import AnimationEffects from '../assets/Animations/hooks/AnimationEffects';
import NewLetter from '../components/NewLetter/NewLetter';
import { AboutData } from '../assets/dummyData/About';
import { Context } from '../context/Products';
import { NewsLetterContent } from '../assets/dummyData/NewsLetterData';
import ModalEmailSuccess from '../components/ModalEmailSuccess/ModalEmailSuccess';
import Helmet from '../components/Helmet';
import logo from "../assets/img/prodejny_map.png"
import { seo } from '../assets/dummyData/seo';

const AboutPage = () => {
    const [{ lang }] = useContext(Context);
    const { singleRefs } = AnimationEffects(['NewLetter'], [] ,'opacity', 0.2 , 0.12);
    const [shoeModalEmail, setShoeModalEmail] = useState(false);

    const modalEmail = () => {
        setShoeModalEmail(true);
        const body = document.body;
        body.classList.add("modal-open");
        setTimeout(() => {
            setShoeModalEmail(false);
        }, 500);
    }
    return (
        <>
            <Helmet
                title={seo[lang].about.title}
                metaDesc={seo[lang].about.description}
                lang={lang}
                opengraphImage={logo}
                twitterImage={logo}
            />
            <div id="page-about">
                <About aboutData={AboutData[lang]} footerText={AboutData.footerText[lang]} />
            </div>
            <div className="opacity-0" ref={singleRefs.elements.NewLetter.ref}>
                <NewLetter data={NewsLetterContent[lang]} openModal={modalEmail} lang={lang} />
            </div>
            <ModalEmailSuccess open={shoeModalEmail} />
        </>
    )
}

export default AboutPage;
